module.exports = "images/9ans.8c79f598.png";